// File: UserProfile.jsx
// Updated Version

import React, { useState, useEffect } from 'react';
import styles from './UserProfile.module.css';
import { useGoogleLogin } from '@react-oauth/google';
import UserInfoCard from './UserInfoCard';
import LicenseStatus from './LicenseStatus';
import ManageBilling from './ManageBilling';
import { createOrUpdateUser } from '../../api/ApiMaster';

const UserProfile = ({ user, setUser }) => {
  const [subscription, setSubscription] = useState({ plan: 'StoryBook Lite', status: 'Free Plan' });

  useEffect(() => {
    const fetchUserData = () => {
      if (user && user.email !== 'guest@example.com') {
        console.log("User already set:", user);
        setSubscription({ plan: 'StoryBook Premium', status: 'Active' });
      } else {
        console.log("Setting default Guest user.");
        setUser((prevUser) => {
          if (prevUser && prevUser.email !== 'guest@example.com') return prevUser;
          return { name: 'Guest', email: 'guest@example.com', avatar: '' };
        });
        setSubscription({ plan: 'StoryBook Lite', status: 'Free Plan' });
      }
    };

    fetchUserData();
  }, [user, setUser]);

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      console.log("Google login successful:", tokenResponse);
      fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
        headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
      })
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
          return res.json();
        })
        .then(async (data) => {
          const avatarUrl = data.picture || 'https://via.placeholder.com/150';
          const userObject = { name: data.name, email: data.email, avatar: avatarUrl };
          setUser(userObject);

          const saved = await createOrUpdateUser(userObject);
          if (saved) {
            console.log("User saved to backend:", saved);
          }
        })
        .catch((error) => {
          console.error("Failed to fetch user info:", error);
          alert("Error fetching user information. Please try again.");
        });
    },
    onError: (error) => {
      console.error("Login Failed:", error);
      alert("Google Login failed. Please try again.");
    },
  });

  return (
    <div className={styles.userProfilePage}>
      <h1>Account Settings</h1>

      {!user || user.email === 'guest@example.com' ? (
        <button className={styles.googleLoginButton} onClick={() => login()}>
          Login with Google
        </button>
      ) : (
        <>
          <UserInfoCard user={user} />

          <LicenseStatus
            plan={subscription.plan}
            status={subscription.status}
            onManageBilling={() => {}}
          />

          <ManageBilling className={styles.editProfileButton} />

          <button
            className={styles.editProfileButton}
            onClick={() => alert('Edit Profile functionality coming soon!')}
          >
            Edit Profile
          </button>
        </>
      )}
    </div>
  );
};

export default UserProfile;
